class ApiService {
    constructor(SERVICE_LOCATIONS, $http, $q, $rootScope, CONTENT_TYPE) {
        return {
            get: (contentType, id) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + contentType + '/' + id )
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            create: (contentType, item) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + contentType + '/', item)
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            update: (contentType, item) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + contentType + '/update/', item) 
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            delete: (contentType, id) => {
                let deferred = $q.defer();
                $http.delete(SERVICE_LOCATIONS.CPM_API + contentType + '/' + id + '/delete')
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },

            list: (contentType, queryParams) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + contentType + '/list?' + queryParams)
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },
            
            getCurrent: (contentType) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + contentType)
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        if (response.status === 401) {
                            $rootScope.$emit('accessDenied');
                        } else {
                            deferred.reject(response);
                        }
                });
                return deferred.promise;
            },
            
            clone: (entity, targetEntity, contentType) => {
                let deferred = $q.defer();
                $http.put(SERVICE_LOCATIONS.CPM_API + contentType + "/" + targetEntity.id + "/clone/" + entity.id, entity )
                    .then((response) => {
                        deferred.resolve(response);
                    }, (response) => {
                        deferred.reject(response);
                    });
                return deferred.promise;
            },

            post: (path, body, options) => {
                const url = SERVICE_LOCATIONS.CPM_API + path;
                return $http.post(url, body, {
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined
                        }
                    }).then(
                    response => response.data,
                    error => $q.reject(error)  // still reject with full error object
                );
            }

        };
    }

}

angular.module('cpm')
    .service('ApiService', ['SERVICE_LOCATIONS', '$http', '$q', '$rootScope', 'CONTENT_TYPE', ApiService]);
